import { request } from 'root/common/request';
import config from 'root/common/config/config';

export default biz => ({
    data() {
        return {
            positions: [],
            multiPositions: {},
            isAdvSuccess: false,
        };
    },
    created() {
        this.getAdvPostions(biz);
    },
    methods: {
        async getAdvPostions(pageTags, opts = {}) {
            if (!pageTags) {
                return;
            }
            const { data: resBody } = await request({
                url: `${config.facadeDomain}/advertise/v1/get`,
                params: { positions: pageTags, ...opts },
                isNeedToken: false,
            });
            this.positions = resBody && resBody.positions && resBody.positions[biz] ? resBody.positions[biz] : [];
            if (resBody.positions) {
                this.multiPositions = resBody.positions;
            }
            this.isAdvSuccess = true;
        },
        // ? 广告位跳转
        skipToUrl(url) {
            window.location.href = url;
        },
    },
});
